import React, { FC } from 'react';
import { WebhooksPageLayout } from './WebhooksPageLayout';

interface Props {
	children?: React.ReactElement;
}

export const WebhooksPage: FC<Props> = (props) => {
	return (
		<WebhooksPageLayout>
			{props.children}
		</WebhooksPageLayout>
	);
};
